import { render, staticRenderFns } from "./AutoCompleteGuru.vue?vue&type=template&id=55b2e756&"
import script from "./AutoCompleteGuru.vue?vue&type=script&lang=js&"
export * from "./AutoCompleteGuru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports